var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningNotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7333 11.6719L10.8892 8.02637H9.11133L9.27116 11.6719H10.7333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.32269 14.3658C9.51177 14.5523 9.73819 14.6454 10.0019 14.6454C10.1724 14.6454 10.3294 14.6028 10.4733 14.5176C10.6171 14.4298 10.7329 14.3138 10.8209 14.1701C10.9114 14.0236 10.958 13.8624 10.9607 13.6867C10.958 13.4257 10.8608 13.2019 10.669 13.0155C10.4773 12.8291 10.2549 12.7358 10.0019 12.7358C9.73819 12.7358 9.51177 12.8291 9.32269 13.0155C9.1336 13.2019 9.04044 13.4257 9.04302 13.6867C9.04044 13.9503 9.1336 14.1767 9.32269 14.3658Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.376953 17.5002H19.6219L9.99943 0.833496L0.376953 17.5002ZM9.99943 4.16683L3.26371 15.8335H16.7352L9.99943 4.16683Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNotFilled);
export default __webpack_public_path__ + "static/media/warningNotFilled.8d62219d3d5a16f33a68fe84797d2e9e.svg";
export { ForwardRef as ReactComponent };